import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/index.js
// module id = 851
// module chunks = 14